import { Component } from '@angular/core';
@Component({
  selector: 'app-spinner',
  template: `<div class="splash-screen">
    <div class="splash-loader">
      <div class="splash-cube1"></div>
      <div class="splash-cube2"></div>
      <div class="splash-cube4"></div>
      <div class="splash-cube3"></div>
    </div>
  </div>`,
})
export class SpinnerComponent {}
